import { render } from "./TBTX.vue?vue&type=template&id=5e8d8ca2&scoped=true"
import script from "./TBTX.vue?vue&type=script&lang=js"
export * from "./TBTX.vue?vue&type=script&lang=js"

import "./TBTX.vue?vue&type=style&index=0&id=5e8d8ca2&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit\\f_pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8d8ca2"]])

export default __exports__